module.exports = __webpack_public_path__ + "img/1F1EB-1F1EF.516f06a2.svg";